import React from 'react';
import { splitByNewLine } from '../../utils/file-parsers';
import { Link } from 'react-router-dom';
import { ItemsToLinks } from 'routes/LinksInList';


interface Iprops {
    data: string,
}

function renderLinkedListItem(item: string, ItemsToLinks: {[itemName: string]: string}) {
    // Extract prefix, match, and suffix for linking only the matched text
    const prefixMatch = item.match(/^(\s*\d+\.?\s*)/);
    const prefix = prefixMatch ? prefixMatch[0] : '';
    const rest = item.slice(prefix.length);
    let matchedKey = null;
    let matchStart = -1;
    let matchEnd = -1;
    Object.keys(ItemsToLinks).forEach(key => {
        const lowerRest = rest.toLowerCase();
        const idx = lowerRest.indexOf(key);
        if (idx !== -1 && (matchStart === -1 || idx < matchStart)) {
            matchedKey = key;
            matchStart = idx;
            matchEnd = idx + key.length;
        }
    });
    if (matchedKey && ItemsToLinks[matchedKey]) {
        return <>
            {prefix}
            {rest.slice(0, matchStart)}
            <Link to={ItemsToLinks[matchedKey]}>{rest.slice(matchStart, matchEnd)}</Link>
            {rest.slice(matchEnd)}
        </>;
    } else {
        return item;
    }
}

export const PreFormattedList = (props: Iprops) => {
    const { data } = props;

    const lines = splitByNewLine(data);
    const headerString = lines[0];
    const items = lines.slice(2, lines.length);

    return (
        <div>
            <h2>{headerString}</h2>
            <div>
                {items.map((item, index) => (
                    <div className="list-item" key={index}>
                        <span className="pre-list-content">{renderLinkedListItem(item, ItemsToLinks)}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};